import styled from 'styled-components'

const LandingPageContainer = styled.main``

export { LandingPageContainer }
